import axios from 'axios';
import moment from 'moment';
import { cnpj , cpf} from 'cpf-cnpj-validator';
/*eslint-disable no-async-promise-executor */
export default {




    encrypt(text) {
        const CryptoJS = require("crypto-js");
        const secretKey = "sua_chave_secreta_12345";
        const encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    },


    decrypt(encryptedText) {
        try {
            const CryptoJS = require("crypto-js");
            const secretKey = "sua_chave_secreta_12345";
            const base64 = encryptedText.replace(/-/g, '+').replace(/_/g, '/');
            const decrypted = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.parse(base64).toString(CryptoJS.enc.Utf8), secretKey);
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch{
            return null;
        }   
    },




    ripString(texto, limite = 20) {
        if(!texto || texto.length == 0) return '';
        return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
    },

    latLng(){
        return new Promise((resolve) => {


            return resolve(null);  /*
            if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                const { latitude, longitude } = position.coords;
                resolve({ lat : latitude, lng :longitude });
                },
                (error) => {
                    console.error(`Latlng: ${error}`)
                    resolve(null);
                }
            );
            } else {
                resolve(null)
            } */
        });
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], `${filename}.${mime.split('/')[1]}`, {type:mime});
        return file;
    },
    fileSize(bytes) {
        if (bytes < 1) {
            const kb = bytes * 1024; // Converte MB para KB
            return `${kb.toFixed(2)} KB`; // Exibe em KB com duas casas decimais
        } else {
            return `${bytes.toFixed(2)} MB`; // Exibe em MB com duas casas decimais
        }
    },
    testGeneratorRg() {
        let n = [];
        for (let i = 0; i < 8; i++) {
            n[i] = Math.floor(Math.random() * 9);
        }
        let verificador = Math.floor(Math.random() * 10);
        if (verificador === 10) verificador = 'X';
        return `${n[0]}${n[1]}.${n[2]}${n[3]}${n[4]}.${n[5]}${n[6]}${n[7]}-${verificador}`;
    },
    testGeneratorName() {
        const primeirosNomes = [
            'Ana', 'João', 'Maria', 'Carlos', 'Fernanda', 'Paulo', 'Juliana', 'Lucas', 'Beatriz', 'Pedro',
            'Bruno', 'Clara', 'Felipe', 'Larissa', 'Guilherme', 'Renata', 'Marcelo', 'Aline', 'Thiago', 'Camila'
        ];
        const sobrenomes = [
            'Silva', 'Oliveira', 'Santos', 'Souza', 'Pereira', 'Costa', 'Ferreira', 'Almeida', 'Ribeiro', 'Gomes',
            'Melo', 'Barbosa', 'Rocha', 'Martins', 'Lima', 'Araújo', 'Dias', 'Teixeira', 'Fernandes', 'Carvalho',
            'Vieira', 'Monteiro', 'Moura', 'Nunes', 'Freitas', 'Machado', 'Ramos', 'Pinto', 'Cardoso', 'Correia',
            'Cavalcanti', 'Moreira', 'Peixoto', 'Faria', 'Mendes', 'Antunes', 'Castro', 'Barros', 'Macedo', 'Neves'
        ];
        const primeiroNome = primeirosNomes[Math.floor(Math.random() * primeirosNomes.length)];
        const numeroSobrenomes = Math.floor(Math.random() * 3) + 2; // Aleatoriamente escolhe entre 2 e 4 sobrenomes
        let sobrenomeCompleto = '';
        for (let i = 0; i < numeroSobrenomes; i++) {
            let sobrenomeAleatorio = sobrenomes[Math.floor(Math.random() * sobrenomes.length)];
            sobrenomeCompleto += sobrenomeAleatorio + (i < numeroSobrenomes - 1 ? ' ' : '');
        }
        return `${primeiroNome} ${sobrenomeCompleto}`;
    },
    testGeneratorMobile() {
        const ddd = Math.floor(Math.random() * (99 - 10) + 10); // Gera um número de 10 a 99
        const primeiroDigito = 9; // Celulares no Brasil começam com 9
        const parte1 = Math.floor(Math.random() * 90000) + 10000; // Gera um número de 10000 a 99999
        const parte2 = Math.floor(Math.random() * 9000) + 1000;   // Gera um número de 1000 a 9999
        return `(${ddd}) ${primeiroDigito}${parte1}-${parte2}`;
    },

    testGeneratorCPF() {
        let n = [];
        let d1 = 0, d2 = 0;
        for (let i = 0; i < 9; i++) {
            n[i] = Math.floor(Math.random() * 9);
            d1 += n[i] * (10 - i);
            d2 += n[i] * (11 - i);
        }
        d1 = 11 - (d1 % 11);
        if (d1 >= 10) d1 = 0;
        d2 += d1 * 2;
        d2 = 11 - (d2 % 11);
        if (d2 >= 10) d2 = 0;
        return `${n[0]}${n[1]}${n[2]}.${n[3]}${n[4]}${n[5]}.${n[6]}${n[7]}${n[8]}-${d1}${d2}`;
    },
    getDevice(){
        try {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent) && /mobile/i.test(userAgent)) {
                return "Phone";
            }
            if (/iPhone|iPod/i.test(userAgent)) {
                return "Phone";
            }
            if (/iPad/i.test(userAgent) || (/android/i.test(userAgent) && !/mobile/i.test(userAgent))) {
                return "Tablet";
            }
            if (window.matchMedia("(max-width: 767px)").matches) {
                return "Phone";
            } else if (window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches) {
                return "Tablet";
            } else {
                return "Computer";
            }
        } catch{
            return 'Unknown';
        }
    },

    getOS(){
        try {
            var OSNome = "Unknown";
            if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSNome="Windows 10";
            if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSNome="Windows 8";
            if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSNome="Windows 7";
            if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSNome="Windows Vista";
            if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSNome="Windows XP";
            if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSNome="Windows 2000";
            if (window.navigator.userAgent.indexOf("Mac")            != -1) OSNome="Mac/iOS";
            if (window.navigator.userAgent.indexOf("X11")            != -1) OSNome="UNIX";
            if (window.navigator.userAgent.indexOf("Linux")          != -1) OSNome="Linux";

            if((this.getDevice() == 'Phone' || this.getDevice() == "Tablet") && OSNome == 'Linux') {
                OSNome="Android";
            }
            return OSNome;
        } catch{
            return "Unknown";
        }
    },
    decodeQRcode(content){
        try {
            var hash = ``; 
            var origin = ``;
            if(content.includes('http')){
                var stripes = content.split('/')
                if(stripes.length == 7){ //http://localhost:8080/#/public/booking/XXXXXXXXX?origin=BookingConfirmationPDF
                    if(stripes[4] == 'public' && stripes[5] == 'booking'){
                        hash = stripes[6].split('?');
                        if(hash.length > 1){
                            if(hash[1].includes('origin=')){
                                origin = hash[1].split('origin=')[1];
                                if(origin.includes('&')){
                                    origin = origin.split('&')[0];
                                }
                            }
                            hash = hash[0];
                        }
                    }
                }
                if(stripes.length == 8){ //http://localhost:3000/front/?path=/public/booking/XXXXXXXXX?origin=BookingVoucherPDF&document=voucher
                    if(stripes[5] == 'public' && stripes[6] == 'booking'){
                        hash = stripes[7].split('?');
                        if(hash.length > 1){
                            
                            if(hash[1].includes('origin=')){
                                origin = hash[1].split('origin=')[1];
                                if(origin.includes('&')){
                                    origin = origin.split('&')[0];
                                }
                            }
                            hash = hash[0];
                        }
                    }
                }

                if(hash == ''){
                    return null;
                }

                if(hash.length == 0 || hash.length > 100){
                    return null;
                }

                return { hash, origin}
            }
            return  null;

        } catch {
            return null;
        }
    },
    getBrowser(){
        try {
            let userAgent = navigator.userAgent;
            let browserName;

            if (userAgent.indexOf("Firefox") > -1) {
                browserName = "Mozilla Firefox";
            } else if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
                browserName = "Google Chrome";
            } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
                browserName = "Safari";
            } else if (userAgent.indexOf("Edg") > -1) {
                browserName = "Microsoft Edge";
            } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
                browserName = "Opera";
            } else if (userAgent.indexOf("Trident") > -1) {
                browserName = "Internet Explorer";
            } else {
                browserName = "Unknown";
            }

            return browserName;
        } catch{
            return "Unknown";
        }
    },

    apiUrl() {
        var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:3000' : window.location.origin)
        return `${baseUrl}/api`;
    },
    frontUrlPath(path) {
        var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:3000' : window.location.origin)
        return `${baseUrl}/front/?path=${path}`;
    },
    parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    },
    findCep(cep){   
        return new Promise(async (resolve, reject) => {
            try {
                if(!cep)
                    throw new Error('CEP inválido');
    
                const rawCep = parseInt(cep.replace(/[^0-9]/g,''));

                var {data} = await axios.get(`https://brasilapi.com.br/api/cep/v1/${rawCep}`);
                if(data && data.city){
                    var lintCity = data.city.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    lintCity = lintCity.toUpperCase();
                    data.city = lintCity;
                }


                resolve(data);
            } catch (e) {
                console.dir(e);
                reject((typeof e ==  'string' ? e : 'Não foi possível encontrar o CEP informado.'));
            }
        });
    },
    
    findCnpj(cnpj){   
        var _this = this;
        return new Promise(async function(resolve, reject){
            try {
                if(!_this.isCnpjValid(cnpj))
                    return reject(`CNPJ informado não é válido.`)
                const rawCnpj = cnpj.replace(/[^0-9]/g,'');
                const {data} = await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${rawCnpj}`);
                resolve(data);
            } catch (e) {
                console.dir(e);
                reject((typeof e ==  'string' ? e : 'Não foi possível encontrar o CNPJ informado.'));
            }
        });
    },
    isCpfValid (text) {
        if(!text)
            return false; 
        text = String(text).replace(/[^\d]/g, '')
        return cpf.isValid(text);
    },
    isCnpjValid (text) {
        if(!text)
            return false; 
        text = String(text).replace(/[^\d]/g, '')
        return cnpj.isValid(text);
    },

    formatCpf (text) {
        if(!text)
            return ''; 
        return cpf.format(text);
    },
    formatCnpj (text) {
        if(!text)
            return ''; 
        return cnpj.format(text);
    },
    frontUrl() {
        var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:8080/#' : window.location.origin+'/#')
        return baseUrl;
    },
    monthName(month) {
        var list = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];
        return list[month - 1];
    },
    calcRange(range) {

        var start = moment(new Date).format('yyyy-MM-DD');
        var end = moment(new Date).format('yyyy-MM-DD');
        var label = ''
        if (range == 'thisweek') {
            start   = moment(new Date).startOf('week').format('yyyy-MM-DD');
            end     = moment(new Date).endOf('week').format('yyyy-MM-DD');
            label = `This Week (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'lastweek') {
            start   = moment(new Date).subtract(1, "week").startOf('week').format('yyyy-MM-DD');
            end     = moment(new Date).subtract(1, "week").endOf('week').format('yyyy-MM-DD');
            label = `Last Week (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'lastmonth') {
            start   = moment(new Date).subtract(1, "month").startOf('month').format('yyyy-MM-DD');
            end     = moment(new Date).subtract(1, "month").endOf('month').format('yyyy-MM-DD');
            label   = `Last Month (${moment(start).format('MMM YY')}')`
        }
        if (range == 'thismonth') {
            start   = moment(new Date).startOf('month').format('yyyy-MM-DD');
            end     = moment(new Date).endOf('month').format('yyyy-MM-DD');
            label   = `This Month (${moment(start).format('MMM YY')}')`
        }
        if (range == 'today') {
            start  = moment(new Date).format('yyyy-MM-DD');
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Today (${moment(start).format('DD MMM YY')}')`
        }
        if (range == 'yesterday') {
            start  = moment(new Date).subtract(1, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Yesterday (${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last7days') {
            start  = moment(new Date).subtract(7, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 7 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last15days') {
            start = moment(new Date).subtract(15, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 15 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last30days') {
            start = moment(new Date).subtract(30, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 30 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'all') {
            start = `1900-01-01`;
            end =  `2060-01-01`;
            label = `Sem Filtro`
        }
        return { start, end, label };
    },
    uuid(prefix) {
        prefix = prefix || "TEMP_";
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return `${prefix}${uuid}`;
    },
    countries() {
        return ["United States"];
        //return [ "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan (Province of China)", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe" ]
    },
    formatHuman3(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('pt-br');
        var end =  moment(moment.utc(date).local(false));
        return end.format('DD/MM/YYYY HH:mm:ss');
    },
    onlyDate(date) {
        if (date == null) {
            return "-";
        }
        return moment(date).local(true).startOf('date').format('DD/MM/yyyy');
    },
    onlyHour(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('pt-br');
        var end =  moment(moment.utc(date).local(false));
        return end.format('hh:mm A');
    },
    formatHuman2(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('pt-br');
        var end =  moment(moment.utc(date).local(false));
        return end.format('DD/MM/YYYY HH:mm:ss');
    },
    formatHuman1(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('pt-br');
        var end =  moment(moment.utc(date).local(false));
        return end.format('MMM D YYYY');
    },
    md5(str) {
        var MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
        var result = MD5(str);
        return result;
    },
    diffDateDays(date){
        moment.locale('pt-br');
        var now =   moment(moment.utc(date).local(true));
        var end =  moment(moment.utc(new Date()).local(true));
        var duration = moment.duration(now.diff(end));
        return parseInt(Math.ceil(duration.asDays(true)));
    },
    diffDateHumanized(date){
        moment.locale('pt-br');
        var now =   moment(moment.utc(date).local(true));
        var end =  moment(moment.utc(new Date()).local(true));
        var duration = moment.duration(now.diff(end));
        return duration.humanize(true);
    },
}